import { Divider, Stack, Typography } from "@mui/material";
import TextField from '@mui/material/TextField';
import { useState } from "react";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import {Box} from "@mui/material";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import { auth } from "../firebase-config";
import { getAuth, signOut, onAuthStateChanged } from "firebase/auth";
import { db } from "../firebase-config";
import { useEffect } from "react";
import { collection, query, where, getDocs, doc, updateDoc, getDoc, orderBy, limit } from "firebase/firestore";

const CurrentResults = () => {

    const navigate = useNavigate();
    const [songs, setSongs] = useState([]);
    const [currentVotingTitle, setCurrentVotingTitle] = useState("");

    useEffect(() => {
        console.log("useeffect");
        getData();

        return () => {
            setSongs([]);
        }
    }, []);


    async function getData() {
        
        console.log("getdata");
        const q = query(collection(db, "piesne"), orderBy("AktualneHlasy", "desc"), limit(100));

        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
            setSongs( songs_ => [...songs_, doc.data()]);
        });

        const docRef = doc(db, "hlasovanie", "1");
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            console.log("Document data:", docSnap.data());
            setCurrentVotingTitle(docSnap.data().nazov);
          } else {
            // docSnap.data() will be undefined in this case
            console.log("No such document!");
          }
      }

    if(localStorage.getItem("user"))
    return(
        <Stack height="100vh" direction="column" justifyContent="flex-end" spacing={1} sx={{height:'100%', alignItems: 'left', justifyContent: 'center', margin: '8%'}}>
            <Typography variant="h5">Výsledky aktuálneho hlasovania - {currentVotingTitle}</Typography>
            {songs.map((song, index) => (
                <Typography>{index+1}.  {song.Názov} --- {song.AktualneHlasy}</Typography>
            ))}
        </Stack>
    )
    else return(
        <Stack height="100vh" direction="column" justifyContent="flex-end" spacing={3} sx={{height:'100%', alignItems: 'center', justifyContent: 'center'}}>
            <Box sx={{height: '100px'}}></Box>
            <Typography>Neautorizovany vstup!</Typography>
        
        </Stack>
    )
}

export default CurrentResults;